<template>
<div class="chapter">
<div class="inner_page">
<div class="div_autre"><div class="pre" id="pre-002"><div class="exergues"><div class="exer"><p class="txt_courant_centre"><i>Teach us to number our days aright,</i></p><p class="txt_courant_centre last"><i>that we may gain a heart of wisdom.</i></p><div class="exer_source">P<span class="small">SALM</span> 90:12</div></div><div class="exer"><p class="txt_courant_centre"><i>Do not cast me away when I am old;</i></p><p class="txt_courant_centre"><i>do not forsake me when my strength is gone.</i></p><div class="exer_source">P<span class="small">SALM</span> 71:9</div></div></div><div class="dev"><p class="bl"> </p></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre3.vue?0c8c1ee9